export default __webpack_public_path__ + "static/media/signal-5.9cea49bc.svg";